/**
 * Created by mykurisu on 2017/8/8.
 */
import React from 'react'
import {browserHistory} from 'react-router'
import {connect} from 'react-redux'
import {WKTag, WKPgyCheck} from '../wk'
import {renderMoney, TimeStream, isLZWKAPP} from '../../utils';
import { toLecture, toChannel } from '../../utils/connectApp'
import '../../css/wkCommon.css'

import LectureEnter from '../../images/icon-channel-enter.png'
import Running from '../../images/main/index_running_lecture.png'


class CurrencyItem extends React.Component {
    static defaultProps = {
        border: 'top',
        marginBottom: false,
        attr: ''
    };

    renderBorder(type) {
        switch (type){
            case 'top':
                return 'currency-item-border-top';
            case 'bottom':
                return 'currency-item-border-bottom';
            case 'none':
                return 'currency-item-border-none';
            default:
                return 'currency-item-border-top';
        }
    }

    renderLectureMode() {
        const lecture = this.props.content;
        if (lecture.lecture_type === 'password_lecture') {
            return (
                <span className="liveroom-lecture-tag">
                    <i className="icon iconfont icon-suo tag-mode-fontsize"></i>
                </span>
            )
        }
    }

    renderLectureImageMode() {
        const lecture = this.props.content;
        if (lecture.image_mode === 'ppt' && lecture.lecture_mode === 'default'){
            return <WKTag text={'PPT'}/>;
        }
    }

    renderLectureTag() {
        const lecture = this.props.content;
        if (lecture.lecture_mode === 'default'){
            switch (lecture.image_mode) {
                case 'video':
                    return <WKTag text={'视频'}/>;
                case 'audio':
                    return <WKTag text={'音频'}/>;
                default:
                    return true
            }
        }else {
            switch (lecture.lecture_mode) {
                case 'video':
                    return <WKTag text={'视频'}/>;
                case 'audio':
                    return <WKTag text={'音频'}/>;
                default:
                    return true
            }
        }
    }

    renderLectureTime() {
        const lecture = this.props.content;
        if (lecture.status === 'closed'){
            if (lecture.audio_length <= 5){
                return (
                    <p>{'时长' + lecture.audio_length + '分钟'}</p>
                )
                if (this.props.attr === 'mywk_calendar'){
                    return (
                        <p>{TimeStream(lecture.start_timestamp, 'hm')}</p>
                    )
                }

                return (
                    <p>{TimeStream(lecture.start_timestamp, 'YMD')}</p>
                )
            }else {
                return (
                    <p>{'时长' + lecture.audio_length + '分钟'}</p>
                )
            }
        }else {
            if (this.props.attr === 'mywk_calendar'){
                return (
                    <p>{TimeStream(lecture.start_timestamp, 'hm')}</p>
                )
            }

            if (lecture.start_timestamp * 1000 < Date.parse(new Date())){
                return (
                    <p>{TimeStream(lecture.start_timestamp, 'YMD')}</p>
                )
            }else {
                let time = 0;
                if ((lecture.start_timestamp * 1000) - Date.parse(new Date()) >= 86400000){
                    time = TimeStream(lecture.start_timestamp,'-D') + '天后'
                }else {
                    time = TimeStream(lecture.start_timestamp,'-H') + '小时后'
                }
                return (
                    <p>{TimeStream(lecture.start_timestamp, 'YMD')}</p>
                )
            }
        }
    }

    renderLink() {
        const {content, type, attr} = this.props;
        if (type){
            if (type === 'channel' && attr !== 'wk_intro'){
                return `/channel/${content.id}`
            }else if (type === 'channel' && attr === 'wk_intro'){
                return `/channel/${content.id}?st=lzwk_inside&inviter_id=43611198`
            } else if (type === 'lecture' && attr !== 'wk_intro'){
                return `/lecture/${content.id}`
            }else if (attr === 'wk_intro' && type === 'lecture'){
                return `/lecture/${content.id}?st=lzwk_inside&inviter_id=43611198`
            }
        }
    }

    handleClick() {
        const {content, type, attr, ownMethod, channelGranted} = this.props;
        let isResll = null;
        content.is_resell_center!=='undefined' && content.is_resell_center ? isResll = true : isResll=false;
        if (ownMethod) {
            ownMethod && ownMethod()
            return
        }

        if(attr === 'channel_index' && type === 'lecture' && content.lecture_type === "pay_channel" && content.lecture_mode === 'default'){
            let access = this.props.role.is_liveroom_vip || channelGranted
            if (!this.props.role.is_manager) {
                if (!content.is_relay) {
                    if (access) {
                        window.location.href = `/classroom/${content.id}`;
                        return
                    }
                } else {
                    if (channelGranted) {
                        window.location.href = `/classroom/${content.id}`;
                        return
                    }
                }
            }
        }

        let link = '';
        if (isLZWKAPP()) {
            let inviterId = ''
            switch (attr) {
                case 'index_free':
                    inviterId = '46974047'
                    break
                default:
                    break
            }
            if (type === 'channel') {
                toChannel(content.id, inviterId)
            }
            if (type === 'lecture') {
                toLecture({ id: content.id, inviterId: inviterId, lectureMode: content.lecture_mode })
            }
            return
        }
        if (type){
            if ((type === 'channel' || type === 'lecture') && attr !== 'wk_intro') {
                link = `/${type}/${content.id}`
                if (type === 'channel' && (WKPgyCheck.isFromPgy && location.search.indexOf('pgy_zhuanbo') === -1)) {
                    link = `/${type}/${content.id}${location.search}`
                }
                if (isResll) {
                    link = `/${type}/${content.id}?is_resell_center=True`
                }
                if (content.sid) {
                    link = `/${type}/${content.id}?nsid=${content.sid}&lfr=${this.props.liveroomId}`
                }
                if (isResll && content.sid) {
                    link = `/${type}/${content.id}?is_resell_center=True&nsid=${content.sid}&lfr=${this.props.liveroomId}`
                }
                if (content.pgy_st) {
                    link = `/${type}/${content.id}?nsid=${content.sid}&lfr=${this.props.liveroomId}&st=${content.pgy_st}`
                }
            }else if (type === 'channel' && attr === 'wk_intro'){
                link = `/channel/${content.id}?st=${this.props.st}&inviter_id=43611198`;
                this.props.dispatch({
                    type: "STATS_LOG",
                    payload: {
                        action: 'recommend_channel_access',
                        ts: Date.now(),
                        target_id: content.id
                    }
                })
            } else if (attr === 'wk_intro' && type === 'lecture') {
                link = `/lecture/${content.id}?st=${this.props.st}&inviter_id=43611198`;
                this.props.dispatch({
                    type: "STATS_LOG",
                    payload: {
                        action: 'recommend_lecture_access',
                        ts: Date.now(),
                        target_id: content.id
                    }
                })
            }
        }

        if (attr === 'index_free'){
            link = `${content.url}&st=index_free`
        }

        if (type === 'lecture' && attr !== 'index_free' && attr !== 'history') {
            // location.assign(link)
            window.location.href = link
            return
        }

        window.location.href = link
    }

    handleToClassroom(e) {
        const {content} = this.props;
        e.preventDefault() || e.stopPropagation()

        let link = ''
        if (content.lecture_mode === 'default') {
            link = `/classroom/${content.id}`
        } else {
            link = `/lecture/${content.id}`
        }
        window.location.href = link
    }

    render() {
        const {content, type, marginBottom, relayShow, attr, channelGranted, role, channel} = this.props;
        const isPass = (attr === 'channel_index') && (content.lecture_type === 'open_lecture' || channelGranted || (role && role.is_manager) || (role && role.is_liveroom_vip && channel && !channel.is_relay))

        return (
            <div className={"wk-currency-item " + this.renderBorder(this.props.border) + (marginBottom ? ' currency-item-margin-bottom' : '')} onClick={() => this.handleClick()}>
                <div className="currency-item-left">
                    <div className="currency-item-img background-image" style={{backgroundImage: `url(${content.cover_url})`}}>
                        {isPass &&
                        <div className="currency-item-img__mask" onClick={(e) => this.handleToClassroom(e)}>
                            <img className="currency-item-img__enter" src={LectureEnter}/>
                        </div>
                        }
                    </div>
                </div>
                <div className="currency-item-right">
                    <div className="currency-item-right-title">
                        {content.is_preffered &&
                        <WKTag svgType={'yx'} text={'优选'} bgColor={'#F93D3A'} fontColor={'#fff'}/>
                        }
                        {type && type === 'lecture' &&
                        this.renderLectureTag()
                        }
                        {type && type === 'lecture' &&
                        this.renderLectureImageMode()
                        }
                        {relayShow && content.is_relay &&
                        '【转】'
                        }
                        {content.name}
                    </div>
                    <div className="currency-item-right__container">
                        <div className="currency-item-right-mid">
                            {(['closed', 'draft'].indexOf(content.status) === -1 && content.start_timestamp * 1000 < Date.parse(new Date())) &&
                            <div className="currency-item-right-mid">
                                <div className="currency-item-right-mid__running">
                                    <img src={Running} alt=""/>
                                    正在直播
                                </div>
                            </div>
                            }
                        </div>
                        <div className="currency-item-right-bottom">
                            <div className="currency-item-right-bottom_left">
                                <div className="currency-item-right-bottom_left-count-time">
                                    {type && type === 'channel' &&
                                    <p>已更新<span>{content.lecture_count}</span>期</p>
                                    }
                                    {(content.lecture_mode !== 'audio' && content.lecture_mode !== 'video') && (type && type === 'lecture' && attr !== 'history') &&
                                    this.renderLectureTime()
                                    }
                                    {attr === 'history' &&
                                    <p>上次学习：{TimeStream(content.learning_timestamp)}</p>
                                    }
                                </div>
                                {attr !== 'history' &&
                                <div className="currency-item-right-bottom_left-count">
                                    <span>{content.popular}</span>人气
                                </div>
                                }
                            </div>
                            {(type && type === 'lecture' && attr !== 'history' && attr !== 'starting' && attr !== 'channel_index' && attr !== 'mywk_calendar') &&
                            <div className="currency-item-right-bottom_right">
                                {content.lecture_type === 'password_lecture' ?
                                    <p style={{fontSize: '12px'}}>加密</p>
                                    :
                                    role && role.is_liveroom_vip && !role.is_manager && !content.is_relay ?
                                        <p style={{fontSize: '12px'}}>VIP免费</p>
                                        :
                                        (content.money && content.id !== 5297593 ?
                                            !content.limit_money ?
                                                <p>￥{renderMoney(content.money).split('.')[0]}<span>.{renderMoney(content.money).split('.')[1]}</span></p>
                                                :
                                                <div className="currency-item-right-bottom_right4lec">
                                                    <p className="currency-item-right-bottom_right-limit">
                                                        <del>￥{renderMoney(content.money)}</del>
                                                    </p>
                                                    <p>￥{renderMoney(content.limit_money.money).split('.')[0]}<span>.{renderMoney(content.limit_money.money).split('.')[1]}</span></p>
                                                </div>
                                            :
                                                ""
                                        )
                                }
                            </div>
                            }
                            {attr === 'history' &&
                            <div className="currency-item-right-bottom_right">
                                <p style={{color: '#1AAD19', fontSize: '12px'}}>已学{content.learning_rate < 1 ? '1' : Math.round(content.learning_rate)}%</p>
                            </div>
                            }
                            {attr === 'channel_index' &&
                            <div className="currency-item-right-bottom_right">
                                {this.props.channel_index_price}
                            </div>
                            }
                            {type && type === 'channel' ?
                                role && role.is_liveroom_vip && !role.is_manager && !content.is_relay ?
                                    <div className="currency-item-right-bottom_right"><p style={{fontSize: '12px'}}>VIP免费</p></div>
                                    :
                                    <div className="currency-item-right-bottom_right">
                                        {
                                            content.nominal_money > 0 && (
                                                this.props.isShowDelMoney && content.nominal_money !== content.money && (
                                                    <p className="currency-item-right-bottom_right-limit">
                                                        <del>￥{renderMoney(content.money)}</del>
                                                    </p>
                                                )
                                                    
                                            )
                                            
                                        }
                                        {
                                            content.nominal_money > 0 && (
                                                <p>
                                                    ￥{renderMoney(content.nominal_money).split('.')[0]}
                                                    <span>.{renderMoney(content.nominal_money).split('.')[1]}</span>
                                                </p>
                                            )
                                        }
                                    </div>
                                :
                                ""
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default connect(state => ({

}))(CurrencyItem)


// WEBPACK FOOTER //
// ./src/components/wk/WKCurrencyItem.js